/**
 * GA4 events via gtag (loaded in public/index.html).
 * No-op when gtag is unavailable (dev/tests).
 */
export const gtagEvent = (name, params = {}) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    return;
  }

  window.gtag("event", name, {
    page_path: window.location.pathname,
    ...params,
  });
};
